<div
  class="w-100 buttonWrapper"
  #actionWrapper
  [formGroup]="parentForm"
>
  <div class="left-side" [ngStyle]="{ 'margin-left': tabName?.startsWith('INQUIRY:') ? '35px' : '0px', 'top': tabName?.startsWith('INQUIRY:') ? '-4px' : '0px'}">
    <!-- C153176-5273: add disable-nclick directive to prevent multiple consecutive sends due to user N clicks -->
    <div
      disable-nclick
      id="sendButton"
      #sendButton
      [disabled]="isSent && isAttaching"
      (click)="sendInquiry($event, inquiryId, inquiryAction, suggestionConvId, notes)"
      *ngIf="!horizontalView"
      #actionBtn
      class="sendIconBox"
      pTooltip="Send"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
    >
      <!-- C153176-5273: flag to show/hide button -->
      <img src="assets/newMessage/sendIcon.svg" class="defaultIcon" alt="send" />
      <img src="assets/newMessage/sendIconHover.svg"  class="hoverIcon" alt="send"/>
    </div>

    <div
      disable-nclick
      id="sendButton"
      #sendButton
      [disabled]="isSent && isAttaching"
      (click)="sendInquiry($event, inquiryId, inquiryAction, suggestionConvId, notes)"
      *ngIf="horizontalView"
      #actionBtn
      pTooltip="Send"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
      class="sendIconHorizontal"
    >
      <!-- C153176-5273: flag to show/hide button -->
      <img src="assets/newMessage/sendIcon.svg" />
      <div class="sendText">Send</div>
    </div>
    <div class="verticalDivider"  *ngIf="horizontalView"></div>
    <!-- Resolve Button: Starts-->
    <div
      [ngClass]="{'resolveIconBox': true, 'clicked': isClicked}"
      (click)="markResolve(lock, lockedBy)"
      *ngIf="buttons.resolveButton.visible && resolve && !hideOptionsForTaskize"
      id="resolveButton"
      #actionBtn
      pTooltip="Resolve"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
    >
      <!-- C153176-5273: flag to show/hide button -->
      <img src="assets/newMessage/resolveIcon.svg" />
      <div class="horizontalButtonText" *ngIf="horizontalView">Resolve</div>
    </div>
    <div
      [ngClass]="{'resolveIconBox': true, 'clicked': isClicked}"
      (click)="markResolve(lock, lockedBy)"
      *ngIf="buttons.resolveButton.visible && !resolve && !hideOptionsForTaskize"
      id="resolveButton"
      #actionBtn
      pTooltip="Resolve"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
    >
      <!-- C153176-5273: flag to show/hide button -->
      <img src="assets/newMessage/resolveIcon.svg" />
      <div class="horizontalButtonText" *ngIf="horizontalView">Resolve</div>
    </div>
    <input type="hidden" id="resolveFlg" #resolveFlag value="N" />
    <!-- Resolve Button: Ends-->

    <div
      (click)="saveDraft($event, selDraftId, notes)"
      *ngIf="buttons.saveButton.visible && !hideOptionsForTaskize"
      id="saveButton"
      #actionBtn
      class="defaultIconBox"
      pTooltip="Save"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
    >
      <!-- C153176-5273: flag to show/hide button -->
      <img src="assets/newMessage/saveIcon.svg" />
      <div class="horizontalButtonText" *ngIf="horizontalView">Save</div>
    </div>
    <div>
      <!-- <div class="uploadfilecontainer mobile-upload-hide" (click)="uploadFiles.click()" appDragDrop (onFileDropped)="fileEvent($event)"></div> -->

      <input
        name="files"
        id="files"
        type="file"
        multiple="true"
        style="display:none"
        #uploadFiles
        (change)="fileEvent($event.target.files)"
      />
      <!-- C153176-5343: enable drag-drop at ATTACH -->
      <!-- Hode attach icon for Mobile -->
      <button [ngClass]="borderDragDropHighlight? 'attach-field-drop-target' :''" class="d-flex flex-column justify-content-center button attach-field-drop-text"
    appDragDrop (onFileDropped)="fileEvent($event)"
       *ngIf="buttons.attachButton.visible && !isMobile" id="attachButton" #actionBtn>
      <div
      (click)="uploadFile()"
        class="attachIconBox"
        appDragDrop
        (onFileDropped)="fileEvent($event)"
        *ngIf="buttons.attachButton.visible && !isMobile"
        id="attachButton"
        #actionBtn
        pTooltip="Attach"
        tooltipPosition="top"
        tooltipStyleClass="leftTooltip p-tooltip-text"
      >
        <ng-container *ngIf="!isAttaching; else spinnerTpl">
          <img src="assets/newMessage/attachIcon.svg" />
          <div class="horizontalButtonText" *ngIf="horizontalView">Attach</div>
        </ng-container>
        <ng-template #spinnerTpl>
          <p-progressSpinner styleClass="spinner-small"></p-progressSpinner>
        </ng-template>
      </div>
    </button>
    </div>

    <div class="verticalDivider"></div>
    <!-- <div [ngClass]="borderDragDropHighlight? 'attach-field-drop-target' :''" class="d-flex flex-column justify-content-center button attach-field-drop-text" (click)="uploadFile()"
    appDragDrop (onFileDropped)="fileEvent($event)"
       *ngIf="buttons.attachButton.visible && !isMobile" id="attachButton" #actionBtn>
      <img src="assets/newMessage/attachIcon.svg" >
      <span class="attach-field-drop-popup" [ngStyle]="{'visibility': borderDragDropHighlight? 'visible':'hidden'}">Drop files here to upload</span>
    <!-- <button [ngClass]="borderDragDropHighlight? 'attach-field-drop-target' :''" class="d-flex flex-column justify-content-center button attach-field-drop-text" (click)="onReAge()"

       *ngIf="buttons.reAgeButton.visible && !isMobile && displayReAge" id="reAgeButton">
      <img src="assets/context/re-age.svg" class="p-1" class="reAgeIcon" alt="Re-Age">
      <span class="mt-auto">RE-AGE</span>
      <span class="attach-field-drop-popup" [ngStyle]="{'visibility': borderDragDropHighlight? 'visible':'hidden'}">Re-Age</span>
    </button> -->

    <!-- Format Button : Starts-->
    <!-- <button class="d-flex flex-column justify-content-center button mobile-view-hide selected" (click)="fotmatToggle()"
         *ngIf="buttons.formatButton.visible && formatTog" id="formatButton" #actionBtn>
      <img src="assets/newMessage/format.svg" class="p-1">
      <span class="mt-auto">FORMAT</span>
    </button>
    <button class="d-flex flex-column justify-content-center button mobile-view-hide" (click)="fotmatToggle()"
         *ngIf="buttons.formatButton.visible && !formatTog" id="formatButton" #actionBtn>
      <img src="assets/newMessage/format.svg" class="p-1">
      <span class="mt-auto">FORMAT</span>
    </button> -->

    <!-- Format Button : Ends-->

    <!-- Important button: Ends-->

    <!-- Secure button: Starts-->
<!-- <button class="d-flex flex-column justify-content-center button  mobile-view-hide selected" (click)="markSecure()"
          *ngIf="isVisible && buttons.secureButton.visible && secure" id="secureButton" #actionBtn>
      <span class="mt-auto" *ngIf="isVisible">SECURE</span>
    </button>
    <button class="d-flex flex-column justify-content-center button  mobile-view-hide" (click)="markSecure()"
          *ngIf="isVisible && buttons.secureButton.visible && !secure" id="secureButton" #actionBtn>
      <img src="assets/newMessage/secure.svg" class="p-1">
      <span class="mt-auto" *ngIf="isVisible">SECURE</span>
    </button>-->
    <input type="hidden" id="secureFlag" #secureFlag value="N" />
    <!-- Secure button: Ends-->

    <!-- Approval button: Starts-->
    <!-- <button #apprReqdBtn class="d-flex flex-column justify-content-center button  mobile-view-hide selected" (click)="markApprovalRequired()"
          *ngIf="parentForm.controls.imageAttach.value && buttons.approvalButton.visible && approvalReq" id="approvalButton" #actionBtn>
      <img src="assets/newMessage/approval.svg" class="p-1 followUp">
      <span class="mt-auto" *ngIf="parentForm.controls.imageAttach.value">APPROVAL</span>
    </button>
    <button #apprReqdBtn class="d-flex flex-column justify-content-center button  mobile-view-hide" (click)="markApprovalRequired()"
          *ngIf="parentForm.controls.imageAttach.value && buttons.approvalButton.visible && !approvalReq" id="approvalButton" #actionBtn>
      <img src="assets/newMessage/approval.svg" class="p-1 followUp">
      <span class="mt-auto" *ngIf="parentForm.controls.imageAttach.value">APPROVAL</span>
    </button>
    <input type="hidden" id="apprReqdFlag" #apprReqdFlag value="N" /> -->
    <!-- Approval button: Ends-->

    <!-- FollowUp button: Starts-->
 <input type="hidden" id="apprReqdFlag" #apprReqdFlag value="N" />
    <div
      [ngClass]="{'followIconBox': true, 'clicked': isClickedFollowUp}"
      (click)="markFollowUp()"
      *ngIf="buttons.followupButton.visible"
      id="followupButton"
      #actionBtn
      class="followIconBox"
      pTooltip="Flag"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
    >
      <!-- C153176-5273: flag to show/hide button -->
      <img src="assets/newMessage/followupIcon.svg" />
    </div>
    <input type="hidden" id="followupFlag" #followupFlag value="N" />
    <!-- FollowUp button: Ends-->
    <!-- Important button: Starts-->
    <div
      class="impIconBoxClicked"
      (click)="markImportant(true)"
      *ngIf="(buttons.importantButton.visible && imp)"
      id="importantButton"
      #actionBtn
      pTooltip="Mark As Important"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
    >
      <!-- C153176-5273: flag to show/hide button -->
      <img src="assets/newMessage/impIcon.svg" />
    </div>
    <div
      class="impIconBox"
      (click)="markImportant(true)"
      *ngIf="buttons.importantButton.visible && !imp"
      id="importantButton"
      #actionBtn
      pTooltip="Mark As Important"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
    >
      <!-- C153176-5273: flag to show/hide button -->
      <img src="assets/newMessage/impIcon.svg" />
    </div>

    <div
      (click)="scheduleInquiry($event, inquiryId, inquiryAction, suggestionConvId)"
      *ngIf="(buttons.scheduleButton.visible && !hideOptionsForTaskize)||  horizontalView"
      id="scheduleButton"
      #actionBtn
      pTooltip="Schedule"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
      class="scheduleIconBox"
    >
      <img src="assets/newMessage/scheduleIcon.svg" />
    </div>
    <div
      (click)="showSignaturePopup($event, signPop)"
      *ngIf="buttons.signatureButton.visible ||  horizontalView"
      id="signatureButton"
      #actionBtn
      pTooltip="Signature"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
      class="signatureIconBox"
    >
      <img src="assets/newMessage/signatureIcon.svg" />
    </div>
    <div
      (click)="showReAgePopup()"
      *ngIf="(buttons.reAgeButton.visible && !hideOptionsForTaskize) ||horizontalView && !fromNewMessage"
      id="reAgeButton"
      #actionBtn
      pTooltip="Re-Age"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
      class="reAgeIconBox"
    >
     <img src="assets/newMessage/reage.svg" alt="Re-Age"/>
    </div>
    <div
      (click)="showTemplatesPopup($event, templateOptions)"
      (keydown)="showTemplatesPopup($event, templateOptions)"
      *ngIf="(buttons.templateButton.visible && !hideOptionsForTaskize)||  horizontalView"
      id="templateButton"
      #actionBtn
      pTooltip="Template"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
      class="templateIconBox"
    >
      <!-- C153176-5273: flag to show/hide button -->
      <img src="assets/newMessage/templateIcon.svg" />
    </div>
    <div
    (click)="openFormatOption($event, tempPop)"
    *ngIf="(buttons.templateButton.visible && !hideOptionsForTaskize)||  horizontalView && !isFormatOpen"
    id="templateButton"
    #actionBtn
    pTooltip="Format"
    tooltipPosition="top"
    tooltipStyleClass="leftTooltip p-tooltip-text"
    class="formatIconBox"
  >
    <!-- C153176-5273: flag to show/hide button -->
    <img src="assets/newMessage/formatIcon.svg" />
  </div>

  <div
  [class]="secure ? 'secureIconBoxClicked' : 'secureIconBox'"
  (click)="markSecure()"
  *ngIf="buttons.secureButton.visible && setSecureBtnVisisble"
  id="secureButton"
  #actionBtn
  pTooltip="Mark As Secure"
  tooltipPosition="top"
  tooltipStyleClass="leftTooltip p-tooltip-text"
>
  <img src="assets/newMessage/secureIcon.svg" />
</div>
<div class="verticalDivider" *ngIf="currentTab && !currentTab.startsWith('NEW MESSAGE') && !currentTab.startsWith('DRAFT') && !currentTab.startsWith('INQUIRY')" [ngStyle]="{'margin-left': horizontalView ? '10px' : '0px'}"></div>
<input type="hidden" id="urgentFlg" #urgentFlag value="N" />
<div
  *ngIf="buttons.fullScreen.visible && (currentTab &&!currentTab.startsWith('NEW MESSAGE') && !currentTab.startsWith('DRAFT') && !currentTab.startsWith('INQUIRY'))"
  id="fullScreenButton"
  #actionBtn
  class="defaultIconBox"
  pTooltip="Open In New Tab"
  tooltipPosition="top"
  tooltipStyleClass="leftTooltip p-tooltip-text"
  (click)="openInNewTab($event)">
  <img src="assets/newMessage/fullScreenIcon.svg" />
</div>
  </div>
  <div class="right-side" #actionBox>
    <!-- C153176-5273: ellipsis to make action bar responsive-->
    <div
      class="ellipsis-icon"
      *ngIf="buttons.ellipsisButton.visible &&  !horizontalView"
      id="ellipsisButton"
      (click)="showActionMenu($event, actionMenuOptions)"
      #actionBtn
      pTooltip="See more actions"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
    >
      <img src="assets/newMessage/ellipsisIcon.svg" />
    </div>
    <!-- C153176-5578: Reposition Cancel button -->
    <div
      class="closeIconBox"
      (click)="cancel($event, inquiryId, selDraftId)"
      *ngIf="buttons.cancelButton.visible"
      id="cancelButton"
      #actionBtn
      pTooltip="Close"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text"
    >
      <div class="cancleButtonText" *ngIf="horizontalView">Cancel</div>
      <img src="assets/newMessage/messageCloseIcon.svg" />
    </div>
    <app-re-age #reAge></app-re-age>
    <!--C153176-5273: ellipsis-triggered context menu-->
    <p-overlayPanel
      [styleClass]="'action-overlay-options action-wrapper'"
      id="actionMenuOptions"
      #actionMenuOptions
      [appendTo]="actionBox"
    >
      <p-listbox
        styleClass="actionListOption"
        [options]="contextmenuItems"
        (click)="onActionMenu($event, actionMenuOptions, signPop)"
        [style]="{ 'border': 'none', 'box-shadow': 'none' }"
      >
        <ng-template let-menuOption pTemplate="item">
          <button
            type="button"
            class="action-menu-items"
            (mouseover)="handleMenuHover($event, menuOption)"
            (focus)="handleMenuHover($event, menuOption)"
          >
            <span class="replyOptionsText">{{menuOption.label}}</span>
            <svg *ngIf="menuOption.label === 'Template' || menuOption.label === 'Signature'"
                 width="8"
                 height="12"
                 viewBox="0 0 8 12"
                 fill="none"
                 style="margin-left: 27px;"
                 xmlns="http://www.w3.org/2000/svg"
                 >
                  <path id="Path 10"
                        d="M1.75 1L6.25 6L1.75 11"
                        stroke="#021E48"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        />
            </svg>
          </button>
        </ng-template>
      </p-listbox>
    </p-overlayPanel>
    <p-overlayPanel
      id="templateOptions"
      #templateOptions
      [styleClass]="templateFromTab ? 'action-overlay-options action-template-tab-wrapper' : 'action-overlay-options action-template-wrapper'"
      [appendTo]="'body'"
    >
      <p-listbox
       styleClass="actionListOption"
        [options]="templates"
        [style]="{ 'border': 'none', 'box-shadow': 'none' }"
        (click)="onTemplateChange($event, templateOptions)"
      >
        <ng-template let-menuOption pTemplate="item">
          <div class="action-menu-items" >
            <span class="replyOptionsText">{{menuOption.label}}</span>
          </div>
        </ng-template>
      </p-listbox>
    </p-overlayPanel>
  </div>
</div>

<!-- signature Popup  start-->
<p-overlayPanel #signPop [appendTo]="'body'" styleClass="signaturePopup">
  <div class="signatureBody">
    <ul *ngIf="signatures && signatures.length > 0">
      <li *ngFor="let sign of signatures" class="signatureBox">
        <button
         type="button"
         (click)="onSignatureChange(sign.label, signPop)"
         class="d-flex flex-row signatureBoxElement"
        >
          <div class="fieldWrapper">
            <div class="name">{{sign.label}}</div>
            <div class="desc" [innerHTML]="sign.value"></div>
          </div>
        </button>
      </li>
    </ul>
    <div *ngIf="!signatures || signatures.length === 0" class="signatureBox">
      No signature present
    </div>
  </div>
</p-overlayPanel>
<!-- signature Popup end-->

<!-- signature Popup start-->
<!-- <p-overlayPanel #tempPop [appendTo]="'body'" styleClass="templatePopup">
  <div class="templatesBody">
    <ul>
      <li *ngFor="let template of templates">
        <div class="d-flex flex-row">
          <div class="fieldWrapper">
            <div class="name">{{template.label}}</div>
            <div class="desc">{{template.value}}</div>
          </div>
          <div class="icon">
            <button
              class="d-flex flex-column button justify-content-center"
              (click)="onTemplateChange(template.label, tempPop)"
            >
              <img src="assets/newMessage/add-blue.svg" class="p-1" />
              <span>ADD</span>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</p-overlayPanel> -->
<!-- signature Popup  end-->

<!-- Save Draft Confirmation Pop up - Start -->
<p-confirmDialog #cd header="Confirm Action"  rejectIcon="No" acceptIcon="No" [styleClass]="'confirm-overlay='" >
  <ng-template pTemplate="headless" >
    <div class="notes-modal-content">
      <div class="header">
        <div class="header-title">Confirm Actions</div>
        <div class="dialogClose" (click)="cd.reject()">
          <img src="assets/Inbox/close_icon_white.svg" alt="close" />
        </div>
      </div>
      <div class="">
        <!-- <label for="notes">{{confirmMessage}}</label> -->
        <div class="d-flex w-100 align-items-center justify-content-center">
          <div class="margin-box" [innerHTML]="getFormattedText(confirmMessage)"></div>
      </div>
      </div>
      <p-footer>
        <div class="d-flex flex-row flex-wrap  btn-wrapper px-3  justify-content-center">
          <button type="button" class=" clear-btn1 " (click)="cd.reject()">No</button>
          <button class=" search-btn1" (click)="cd.accept()">Yes</button>
        </div>
      </p-footer>
    </div>
  </ng-template>
</p-confirmDialog>


<!-- Save Draft Confirmation Pop up - End -->

<!-- Schedule Message Pop up - Start -->
<schedule-message (timeEvent)="onTimeChanged($event)"></schedule-message>
<!-- Schedule Message  Pop up - End -->

<p-toast
  position="center"
  (onClose)="onReject()"
  styleClass="custom-toast"
  key="custom"
  [baseZIndex]="5000"
></p-toast>

<p-toast styleClass="custom-toast" key="sendInquiry"></p-toast>

<!-- Passpord Protection popup Start-->

<p-dialog
  [(visible)]="displayPasswordProtection"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [appendTo]="'body'"
  styleClass="attachmentPassword"
  [closable]="false"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [closeOnEscape]="true"
  [style]="{
    width: '440px',
    height:'368px',
    borderRadius: '25px'
}"
>
<div class="attachmentPasswordContent">
  <div class="attachmentPasswordHeader">
    <span>Password Protection</span>
    <button class="attachmentPasswordClose" (click)="cancelPasswordProtection()">
      <img src="assets/Inbox/close_icon_white.svg" alt="close" />
    </button>
  </div>
  <div class="attachmentContent">

    <form
    class="form-horizontal"
    [formGroup]="passwordProtectionForm"
    (ngSubmit)="saveAllAttachedFiles()"
  >
    <div id="createnew" >
      <div class="d-flex flex-row align-items-start" *ngIf="showAllUnSupportedFilesList.length > 0 || showAllSupportedSecuredFilesList.length > 0">
        <label for="pwdWarning" [attr.for]="'pwdWarning'" class='pwdWarning'> Password Protection NOT applicable for .png, .jpg, .jpeg, .gif, .txt, .eml or .html files.</label>
      </div>
      <div class="d-flex flex-row align-items-start mt-2 mb-2"
        *ngIf="errMsgMultipleDotsInFilename">
        <label for="unsupportedWarning" [attr.for]="'unsupportedWarning'" class='unsupportedWarning'> Below uploaded file name contains unsupported “.” characters which are replaced by “_”.</label>
      </div>
      <div class="d-flex flex-row align-items-start mt-2 mb-2" *ngIf="errMsgRestrcitedCharsInFilename">
        <label for="unsupportedWarning" [attr.for]="'unsupportedWarning'" class='unsupportedWarning'> Below uploaded file name
          contains unsupported characters which are replaced by “_”.</label>
      </div>
      <div class="d-flex flex-row align-items-start mt-3">
        <label for="notes" [attr.for]="'selectAll'" class="attachmentLabel"
              [ngStyle]="(showAllSupportedUnSecuredFilesList.length === 0 && showAllSupportedSecuredFilesList.length === 0) ? {'color': '#8A8A8A'} : {}">
               Select Files for Password Protection:
        </label>
      </div>

      <div class="custom-control custom-checkbox checkBoxControl align-items-center mt-2">
        <input
          type="checkbox"
          [attr.id]="'selectAll'"
          name="selectAll"
          #attachmentSelectAllCheckBox
          value="selectAll"
          (change)="selectAllFiles($event)"
          class="customCheckbox"
        />
        <label *ngIf="attachmentSelectAllCheckBox.disabled" class="custom-control-label" [attr.for]="'selectAll'" style='color: #979797;'>Select All</label>
        <label *ngIf="!attachmentSelectAllCheckBox.disabled" class="custom-control-label" [attr.for]="'selectAll'">Select All</label>
      </div>
      <div class="scrollFileList">
        <div #showAllSupportedUnSecuredFiles >
          <div
          class="custom-checkbox custom-control mt-2" style="display: flex; flex-direction: row;"
            *ngFor="let fileName of showAllSupportedUnSecuredFilesList;  let i = index"
          >
            <input
              type="checkbox"
              name="{{fileName.fileName}}"
              [attr.id]="'file'+i"
              value="{{fileName.fileName}}"
              class="customCheckbox"
         
            />
            <label class="custom-control-label" [attr.for]="'file'+i">
              <!-- {{fileName.fileName}} -->
             {{(fileName?.fileName.length>40) ? (fileName?.fileName | slice:0:40)+'...':(fileName?.fileName)}}
              </label
            >
          </div>
        </div>
        <div #showAllSupportedSecuredFiles>
          <div
            class="custom-control custom-checkbox align-items-center mt-2" style="display: flex; flex-direction: row;"
            *ngFor="let fileName of showAllSupportedSecuredFilesList; let i = index"
          >
            <input
              type="checkbox"
              name="{{fileName.fileName}}"
              [attr.id]="'file'+i"
              value="{{fileName.fileName}}"
              class="customCheckbox"
              style='display: flex;'
              disabled
              checked
            />
            <label class="custom-control-label" [attr.for]="'file'+i">
              {{(fileName?.fileName.length>40) ? (fileName?.fileName | slice:0:40)+'...':(fileName?.fileName)}}</label
            >
          </div>
        </div>
        <div #showAllUnSupportedFiles>
          <div
            class="custom-control custom-checkbox align-items-center mt-2" style="display: flex; flex-direction: row;"
            *ngFor="let fileName of showAllUnSupportedFilesList; let i = index"
         
          >
            <input
              type="checkbox"
              name="{{fileName.fileName}}"
              [attr.id]="'file'+i"
              value="{{fileName.fileName}}"
              class="customCheckbox"
              style='display: flex;'
              disabled
            />
            <label class="custom-control-label" style="color: #979797;" [attr.for]="'file'+i">
              {{(fileName?.fileName.length>40) ? (fileName?.fileName | slice:0:40)+'...':(fileName?.fileName)}}</label
            >
          </div>
        </div>
      </div>
      <label [attr.for]="'password-input'" for="password-input" class="attachmentLabel pb-1" style='padding-top: 16px;'   [ngStyle]="(showAllSupportedUnSecuredFilesList.length === 0 && showAllSupportedSecuredFilesList.length === 0) ? {'color': '#8A8A8A'} : {}">
       Password:</label>
      <div class="attachmentPasswordSection">
        <div class="">
          <input
            id="password-input"
            type="password"
            placeholder="Enter Password"
            formControlName="fileInfo"
            class="w-240 t-box inp-txt-mng input-placeholder disabledPasswordInput"
            pInputText
            #fileInfo
            [disabled]="showAllSupportedUnSecuredFilesList.length === 0 && showAllSupportedSecuredFilesList.length === 0"
          />
        </div>
        <div class="custom-checkbox custom-control checkBoxControl">
          <input
            type="checkbox"
            (click)="showPassword($event)"
            class="customCheckbox"
            [attr.id]="'ShowPassword'"
            [disabled]="showAllSupportedUnSecuredFilesList.length === 0 && showAllSupportedSecuredFilesList.length === 0"
          />
          <label class="custom-control-label showPasswordText" [attr.for]="'ShowPassword'"
              [ngStyle]="(showAllSupportedUnSecuredFilesList.length === 0 && showAllSupportedSecuredFilesList.length === 0) ? {'color': '#8A8A8A'} : {}">
            Show Password</label
          >
        </div>
      </div>
      <span style="margin-left: 10px;color:red;" [innerHTML]="errorMsg"></span>
    </div>
    <div class="attachmentPasswordFooter">
    <button
    type="reset"
      pButton
      label="Cancel"
      class="cancel-button"
      (click)="cancelPasswordProtection()"
    ></button>
    <button
    type="submit"
      pButton
      label="Continue"
      class="submit-button"
    ></button>
  </div>
  </form>
  </div>
</div>

</p-dialog>
<!-- Passpord Protection popup End-->

<p-dialog [visible]="displayError && !displayPasswordProtection" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal settingsModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
  [closeOnEscape]="true" [style]="{'max-width':'501px', 'width': '100%'}" [resizable]="false">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
     
                  <div class="d-flex" style="flex: auto; margin-left:4px">
                    <div style="display: flex; align-items: center; gap: 8px;">
                    <img src="assets/Inbox/info.svg" alt='Info' class="icon-setting-out"
                      (mouseover)="showUploadFilesPanel($event, info_upload_files)" (mouseout)="info_upload_files.hide()" (onFocus)="showUploadFilesPanel($event, info_upload_files)"/>
                    <span
                      style="font-size: 14px;color:#FFFFFF;font-family:OpenSansSemiBold,sans-serif;line-height: 21.79px;font-weight: 600; margin-right:5px">
                      Information
                    </span>
                    </div>
                    <!-- (mouseout)="info_upload_files.hide()" -->
                    <p-overlayPanel [styleClass]="'icon-info-upload-files inquiry_rules_info'" [appendTo]="'body'" #info_upload_files
                      [baseZIndex]="9999">
                      <div class="flex-row mb-0.3" style="font-family: 'OpenSans',sans-serif">
                        <div class="info-heading">
                          List of extensions restricted to upload:-
                        </div>
                        <div class="info-subinfo">
                          {{qmaConstant?.QMA_UPLOAD_FILES_INFO}}
                        </div>
                      </div>
                      <div class="flex-row mb-0.3  mt-2" style="font-family: 'OpenSansBold',sans-serif; font-size: 12px;font-weight: 700;">
                        <div class="info-heading">
                          List of restricted characters in file name to upload:-
                        </div>
                        <div class="info-subinfo" style="margin-bottom: 8px;">
                          {{Qma_blocked_file_name_chars}}
                        </div>
                      </div>
                    </p-overlayPanel>
                  </div>
      <button type="button" (click)="closeModal('error')" class="d-flex flex-row close qma-text"
        style="margin: 0px 6px 0px 0px;">
        <img src="assets/qwyn/icons/close-grey.svg" alt="Close">
      </button>
    </div>
  </p-header>
  <div style="padding: 20px 24px 20px 24px">
  <div class="dlg-body mb-2"  *ngIf="errMsg">
    Below uploaded file extensions are not supported in QWYN. Please refer to the
    information icon for more details.
  </div>
  <div class="dlg-body" [innerHTML]="errMsg"></div>
  <div
    class="dlg-body mb-2"
    *ngIf="errMsgRestrcitedCharsInFilename"
  >
    Below uploaded file name contains special characters which is replaced by _
    Please refer to information icon for more details
  </div>
  <div class="dlg-body"  [innerHTML]="errMsgRestrcitedCharsInFilename" *ngIf="errMsgRestrcitedCharsInFilename"></div>
  <div
    class="dlg-body mb-2"
    *ngIf="errMsgMultipleDotsInFilename"
  >
    Below uploaded file name contains multiple . characters which is replaced by
    _
  </div>
  <div class="dlg-body"  [innerHTML]="errMsgMultipleDotsInFilename" *ngIf="errMsgMultipleDotsInFilename"></div>
  </div>
</p-dialog>

<!--C153176-5298 |  Confirmation for force Resolve -->
<p-dialog
  [(visible)]="forceResolveConfirm"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [appendTo]="'body'"
  [styleClass]="'contextMenuModal'"
  [closable]="false"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [closeOnEscape]="true"
  [style]="{'max-width':'500px','width':'50%'}"
>
  <p-header>
    <div
      class="d-flex flex-row align-items-center justify-content-between mx-2 mt-1"
    >
      <h6 class="success-title">FORCE RESOLVE</h6>
      <button
        type="button"
        (click)="cancelResolveMark()"
        class="d-flex flex-row close qma-text"
      >
        <img src="assets/Inbox/close_icon_u73.svg" />
      </button>
    </div>
  </p-header>
  <div class="mx-2">
    <div class="d-flex flex-row align-items-center mb-4 pb-4">
      <div class="success-msg" [innerHTML]="forceResolveConfirmMsg"></div>
    </div>
  </div>
  <p-footer>
    <div
      class="d-flex flex-row flex-wrap bottom-button-holder px-3 pb-2 pt-3 justify-content-end"
    >
      <button class="btn search-btn me-4" (click)="setResolveMark()">Ok</button>
      <button class="btn clear-btn" (click)="cancelResolveMark()">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  [(visible)]="invaliDEmailIdExists"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [appendTo]="'body'"
  [closable]="true"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [closeOnEscape]="true"
  width="25%"
  [draggable]="true"
  [styleClass]="'nlp-modal-pop-up'"
>
  <p-header> Invalid Email Ids </p-header>
  <div>
    <h6
      style="font-weight: 800;
  font-family: 'OpenSansLight',sans-serif;
  font-size: 12px;"
    >
      Please correct below emailIds to proceed :-
    </h6>
    <div
      *ngFor="let invalidId of invalidEmailIds"
      style="font-family: 'OpenSans',sans-serif;
  font-size: 12px;"
    >
      {{invalidId}}
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="displayApiError"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [appendTo]="'body'"
  [styleClass]="'blacklistModel'"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [closeOnEscape]="true"
  [style]="{width: '30%'}"
  [closable]="false"
>
  <p-header>
  <div class="d-flex flex-row align-items-center justify-content-between">
    <span
      style="font-size: 16px;color:#FFFFFF;font-family:OpenSansSemiBold,sans-serif;line-height: 21.79px;font-weight: 600;">
      Error</span>
      <button type="button" (click)="closeApiErrorPopup()" class="d-flex flex-row close qma-text">
        <img src="assets/Inbox/close_icon_u73.svg" alt='Close'/>
      </button>
    </div>
  </p-header>
  <div class="mx-2">
    <div class="d-flex flex-row align-items-center p-2">
      <div class="success-msg">File was not uploaded, please try again later or contact QWYN Support</div>
    </div>
  </div>
</p-dialog>
